
<template>
    <div>
		<div class="row">
			<div class="col-8 mb-4">
				<h1>
                    <img src="../../assets/branding/molar-logo.png" alt="MOLAR" style="height: 2em; vertical-align: middle; margin-right: 0.4em;" class="mb-2"/>
                    <br />
                    {{ $t("molar-caps") }}
                </h1>
			</div>
            <div class="col-4 mb-4" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
                <button 
                    class="btn btn-primary float-right"
                    @click="$router.push(`/curriculum-mapping/learning-outcomes/report`)"
                >
                    {{ $t('report') }} <b-icon icon="bar-chart-steps" class="ml-1" />
                </button>
                
                <button 
                    class="btn btn-outline-primary float-right mr-2"
                    @click="$router.push(`/curriculum-mapping/learning-outcomes/unmapped`)"
                >
                    {{ $t('see-unmapped') }} <b-icon icon="flag" class="ml-1" />
                </button>
            </div>
		</div>
		<div class="row">
            <div class="col-12">
                <LearningOutcomeSearch />
            </div>
            <div class="col-12">
                <CurriculumSelector :curricula="curricula" @explore="scrollToCurriculaSearch" />
            </div>
            <div class="col-md-6" v-for="(item,classkey) in learningoutcomesclasses" :key="classkey">
                <LOSelector
                    :LOclass="item"
                    :title="classkey"
                    :mapping_progress="mapping_progress"
                    :loService="loService"
                    @saved="listOutcomesByClass"
                />
            </div>
			<div class="col-md-8">
                <div v-if="new_root" class="card mb-2">
                    <h4 class="card-header">{{ $t('new-curriculum') }}</h4>
                    <div class="card-body">
                        <TextInput :label="$t('title')" v-model="node.title">
                        </TextInput>
                        <TextAreaInput :label="$t('notes')" v-model="node.note"></TextAreaInput>
                        <button class="btn btn-secondary float-right" @click="saveRoot" :disabled="!node.title">{{ $t('add') }}</button>
                    </div>
                </div>
				
			</div>
			<!-- <div class="col-md-4">
				<div class="list-group border-radius-2 no-border mb-3">
                    <router-link to="/curriculum-mapping/components" class="list-group-item" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">{{ $t('components') }}</router-link>
					<router-link to="/curriculum-mapping/learning-outcomes" class="list-group-item">{{ $t('learning-outcomes') }}</router-link>
					<router-link to="/curriculum-mapping/learning-outcomes/unmapped" class="list-group-item">{{ $t('unmapped-learning-outcomes') }}</router-link>
					<router-link to="/curriculum-mapping/learning-outcomes/report" class="list-group-item">{{ $t('learning-outcomes-report') }}</router-link>
				</div>
			</div> -->
		</div>
        <div class="row" ref="curriculaSearchRow">
            <CurriculaSearch class="col-12" />
        </div>
    </div>
</template>
<script>
//import Table from "src/components/Table/Table.vue";
import LearningOutcomes from "src/modules/learningoutcomes.js";
import LOSelector from "../../components/MOLAR/LOSelector.vue";
//import NodeDrilldownSearch from "../../components/CurriculumMapping/NodeDrilldownSearch.vue";
import CurriculumSelector from "../../components/MOLAR/CurriculumSelector.vue";
import CurriculaSearch from "../../components/MOLAR/CurriculaSearch.vue";
import LearningOutcomeSearch from "../../components/MOLAR/LearningOutcomeSearch.vue";

export default {
	components: {
        //Table,
        LOSelector,
        //NodeDrilldownSearch,
        CurriculumSelector,
        CurriculaSearch,
        LearningOutcomeSearch
	},
    data() {
        return {
        	total: 0 ,
            filters: {
                page: 1,
                page_size: 30,
                search: '',
                sort: '',
                order: '',
            },

            loading: true,
            submitting: false,

            curricula: [],
            curriculummaps: [],
            new_root: false,
            node:{},

            learningoutcomesclasses: {},

            lo_data: {},
            mapping_progress: {},
            loService: null
        }

    },
    mounted() {
        this.listCurricula();

        this.loService = new LearningOutcomes();
        this.listOutcomesByClass();

        this.getReportConfig();
    },
    methods: {
        scrollToCurriculaSearch() {
            this.$refs.curriculaSearchRow.scrollIntoView({ behavior: 'smooth' });
        },
        listCurricula() {
            if (this.submitting) return;
            this.submitting = true;
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listroots`,{
                method: "post",
                data: this.filters
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.curricula=res.results;
            		this.loading = false;
                	this.filters.page = res.pagination.page
                	this.filters.page_size = res.pagination.page_size
                	this.total = res.pagination.total
				} else {
					this.$log.info.call(this, status)
				}
            	this.submitting = false;
			}).catch(error => {
            	this.submitting = false;
				this.$log.error.call(this, error);
			});
        },
        listOutcomesByClass() {
            this.submitting = true;
            // eslint-disable-next-line no-unused-vars
            const { page, page_size, ...groupFilters } = this.filters;
            this.loService.listGroups(groupFilters)
            .then(res => {
                let classes = {
                    "0" : [],
                    "1" : []
                }

                res.results.forEach((item) => {
                    if (item.class === "0" || item.class === "1") {
                        classes[item.class].push(item);
                    }
                });

                this.learningoutcomesclasses = classes;
                return this.getLOData();
            })
            .finally(() => (this.submitting = false));
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters }
            this.listCurricula()
        },
        saveRoot(){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/save`,{
                method: "post",
                data: this.node
            })
            .then((res) => {
				if (res.status === "SUCCESS") {
                    this.listCurricula()
                    this.new_root = false
				} else {
					this.$log.info.call(this, status)
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
        },
        openDeleteDialog(item) {
            this.selectedItem = item;

            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t('delete-{e}-warning',{e: this.$t('curriculum')}),
                cancelBtn: true,
                confirmCallBack: this.removeItem,
            })
        },
        removeItem() {
            if (!this.selectedItem) return ;
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/delete`, {
                method: 'POST',
                data: { 
                    id: this.selectedItem.id 
                }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error deleting curriculum')
                this.curricula = this.curricula.filter(el => el.id !== this.selectedItem.id)
            }).catch(err => {
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-delete-{e}',{e:this.$t('curriculum')}),
                })
            }).finally(() => {
                this.selectedItem = undefined
            })
        },
        getReportConfig(){
			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/report/molar_internal`, {
				cache: false,
				init: {
					method: "post",
					body: {
					}
				}
			})
			.then(res => {
				if (res.status === "SUCCESS") {
					this.$log.info.call(this, "Report config loaded");
					this.mapping_progress = res.result;
				} else {
					this.$log.error.call(this, "Could not fetch report widget settings");
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
		},
        getLOData(){
            return this.$cfetch(`${this.$settings.APIBaseURL}/reporting/dataelement/molar_mapped_los`, {
                method: 'POST',
                data: { }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching report data element')
                this.lo_data = res.result.values.results.global
                
                if(this.learningoutcomesclasses){
                    for (const classKey in this.learningoutcomesclasses) {
                        this.learningoutcomesclasses[classKey].forEach(item => {
                            const groupKey = 'group_' + item.id
                            this.$set(item, 'mapped', this.lo_data[groupKey] || 0)
                            this.$set(item, 'total', this.lo_data[groupKey + '_total'] || 0)
                        })
                    }
                }
            }).catch(err => {
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    //content: this.$t('error-delete-{e}',{e:this.$t('curriculum')}),
                })
            }).finally(() => {
                this.selectedItem = undefined
            })
        }
    },
    computed: {
    }
};
</script>
